import type { TPlayerGlassState } from '@lucimark/shared/helpers/playerGlassState'

export type TPlayerGlassDiagnosticsSample = {
  glassState: TPlayerGlassState | null
  skippedUncachedFrameCount: number
}

let sample: TPlayerGlassDiagnosticsSample = {
  glassState: null,
  skippedUncachedFrameCount: 0
}

export function setPlayerGlassDiagnosticsSample(next: TPlayerGlassDiagnosticsSample): void {
  sample = next
}

export function peekPlayerGlassDiagnosticsSample(): TPlayerGlassDiagnosticsSample {
  return sample
}
